import { render, staticRenderFns } from "./AddShop.vue?vue&type=template&id=06d3143e&scoped=true"
import script from "./AddShop.vue?vue&type=script&lang=js"
export * from "./AddShop.vue?vue&type=script&lang=js"
import style0 from "./AddShop.vue?vue&type=style&index=0&id=06d3143e&prod&lang=scss"
import style1 from "./AddShop.vue?vue&type=style&index=1&id=06d3143e&prod&lang=scss&scoped=true"
import style2 from "./AddShop.vue?vue&type=style&index=2&id=06d3143e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d3143e",
  null
  
)

export default component.exports